import React, { useMemo } from 'react';
import { Star } from 'lucide-react';

interface StarDot {
  left: number;  // %
  top: number;   // %
  size: number;  // px
  delay: number; // s
  duration: number; // s
  rotate: number; // deg
  opacity: number;
}

// Pequeñas estrellas doradas flotando sobre el hero — contrapunto decorativo
// al logo/titular. Se generan en un seed fijo para que no parpadeen al
// re-renderizar pero mantengan una distribución natural.
const SEED: [number, number, number, number, number, number, number][] = [
  [8, 18, 12, 0, 7, 15, 0.35],
  [18, 72, 10, 1.2, 8, -10, 0.3],
  [26, 32, 14, 2.4, 9, 25, 0.4],
  [36, 82, 9, 0.6, 7.5, 40, 0.28],
  [46, 12, 11, 3, 8.5, -20, 0.38],
  [54, 68, 13, 1.8, 9.5, 60, 0.32],
  [62, 22, 10, 2.1, 7.2, 5, 0.3],
  [72, 58, 15, 0.3, 10, -35, 0.42],
  [82, 26, 11, 2.7, 8.2, 18, 0.34],
  [92, 74, 9, 1.4, 7.8, -50, 0.26],
  [14, 48, 8, 3.2, 9.8, 28, 0.24],
  [40, 50, 10, 1.7, 8.8, -8, 0.3],
  [68, 40, 12, 0.9, 9.2, 45, 0.36],
  [86, 52, 8, 2.5, 7, -25, 0.26],
];

const HeroStars: React.FC = () => {
  const stars: StarDot[] = useMemo(
    () =>
      SEED.map(([left, top, size, delay, duration, rotate, opacity]) => ({
        left,
        top,
        size,
        delay,
        duration,
        rotate,
        opacity,
      })),
    []
  );

  return (
    <div className="landing-hero-stars" aria-hidden="true">
      {stars.map((s, i) => (
        <span
          key={i}
          className="landing-hero-star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            transform: `rotate(${s.rotate}deg)`,
          }}
        >
          <Star
            size={s.size}
            fill="#FFD702"
            strokeWidth={0}
            color="#FFD702"
          />
        </span>
      ))}
    </div>
  );
};

export default HeroStars;
